import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import { translations } from "./translations";
import type { Language } from "./translations";

interface LanguageContextValue {
  language: Language;
  locale: string;
  setLanguage: (lang: Language) => void;
  t: (typeof translations)[Language];
}

const LanguageContext = createContext<LanguageContextValue>({
  language: "en",
  locale: "en-US",
  setLanguage: () => {},
  t: translations.en,
});

interface LanguageProviderProps {
  language: Language;
  onSetLanguage: (lang: Language) => void;
  children: ReactNode;
}

export function LanguageProvider({
  language,
  onSetLanguage,
  children,
}: LanguageProviderProps) {
  const locale = language === "de" ? "de-DE" : "en-US";
  return (
    <LanguageContext.Provider
      value={{
        language,
        locale,
        setLanguage: onSetLanguage,
        t: translations[language],
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage(): LanguageContextValue {
  return useContext(LanguageContext);
}
